import styled from "styled-components";

export const TablesGridContainer = styled.div`
  margin-top: 15px;
`;

export const TablesGridContainerContent = styled.div`
  flex-direction: column;
`;
export const TablesGridContainerText = styled.div`
  background-color: #8cbcf4;
  padding: 15px 0;
  font-family: Akrobat;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const TablesGridCoontentFilter = styled.div`
  display: flex;
  justify-content: center;
  font-family: Akrobat ExtraBold;
  background-color: #F4F5F5;
  padding: 20px 0;
  margin-bottom: 20px;
  color: #8cbcf4;
`;
export const TablesGridCoontentFilterSelector = styled.div`
  background-color: #fff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0 5px;
  font-size: 13px;
  margin: 0 10px;
  display: flex;
  align-items: center;
label{
  margin-right: 0.5rem;
}
  input {
    border: 0;
    color: #919aae;
  }
`;
export const TablesGridCoontentFilterSelectorButton = styled.button`
  background-color: #8cbcf4;
  color: #fff;
  border: none;
  padding: 0 13px;
  height: 38px;
  font-family: Akrobat;
`;
